import { handleWebmotorsPrice } from "@/helpers/utils";
import { Anotation } from "../anotation/anotation.component";

interface WebmotorsAveragesProps {
    prices: {
        brazilian_price: { armored: boolean; medium_price: string | number; }[];
        state_price: { armored: boolean; medium_price: string | number; }[];
    };
    isVehicle0km: boolean
    isVehicleArmored: boolean
}

export const WebmotorsAverages = ({ isVehicle0km, isVehicleArmored, prices }: Readonly<WebmotorsAveragesProps>) => {
    const { hasArmored, isStateArmored, stateMediumPriceArmored, brazilianMediumPrice, stateMediumPrice, isBrazilianArmored } = handleWebmotorsPrice(prices, isVehicleArmored);

    if (
        isVehicle0km && stateMediumPrice ||
        (isVehicleArmored && !hasArmored) ||
        (!stateMediumPrice && !brazilianMediumPrice) ||
        (stateMediumPrice?.length == 0 && brazilianMediumPrice?.length == 0)
    ) {
        return <Anotation text="Não temos ofertas suficientes para o cálculo do valor Webmotors" />;
    }

    if (isVehicleArmored) {
        if (isStateArmored) {
            return <span data-testid="wm-price" id="wm-price">{stateMediumPriceArmored}</span>;
        }
        if (!isStateArmored && isBrazilianArmored) {
            return <span data-testid="wm-price" id="wm-price">{brazilianMediumPrice}*</span>;
        }
    }

    if ((!stateMediumPrice || stateMediumPrice.length === 0) && (!!brazilianMediumPrice)) {
        return <span data-testid="wm-price" id="wm-price">{brazilianMediumPrice}*</span>;
    }

    return <span data-testid="wm-price" id="wm-price">{stateMediumPrice}</span>;
};